import React from "react";
import { Users, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

/**
 * iter-118: Steeltooth now enforces ONE workgroup per user with
 * automatic full-team sharing of every project / contact / lead /
 * report. The old "Save to Workgroup" copy/move flow is gone — as
 * soon as you're a member of a workgroup, EVERYTHING you own is
 * visible AND editable by every teammate, and vice versa.
 *
 * This dialog now acts purely as a reassurance modal for any legacy
 * button/menu still wired to it. It briefly explains the new
 * behaviour and closes.
 */
export default function SaveToWorkgroupDialog({ open, onOpenChange }) {
    React.useEffect(() => {
        if (!open) return;
        toast.message("Sharing is automatic now", {
            description:
                "Every project, contact, lead, and report is auto-shared with your entire workgroup — no per-item action needed.",
            icon: <ShieldCheck className="w-4 h-4" />,
            duration: 5000,
        });
        onOpenChange?.(false);
    }, [open, onOpenChange]);

    return null;
}

// Preserve the icon for callers that spread props — unused but keeps
// tree-shaking honest against the previous import list.
export { Users };
